import script from "./LecturasComparativasView.vue?vue&type=script&setup=true&lang=js"
export * from "./LecturasComparativasView.vue?vue&type=script&setup=true&lang=js"

import "./LecturasComparativasView.vue?vue&type=style&index=0&id=0d1836fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d1836fe"]])

export default __exports__